<template>
  <div>
    <header class="position-sticky top-0 bg-transparent" style="z-index: 999">
      <!-- Navbar -->
      <nav class="navbar navbar-expand-lg navbar-light" style="box-shadow: none">
        <!-- Container wrapper -->
        <div class="container-fluid px-24">
          <a class="navbar-brand mt-2 mt-lg-0" href="/" style="margin-left: 0.5rem">
            <img
              src="../assets/dashboard-logo.svg"
              width="168"
              height="32"
              alt="SCANAT Logo"
              loading="lazy"
            />
          </a>
          <!-- Right elements -->
          <div class="d-flex align-items-center" style="margin-right: 1.25rem">
            <LanguageSwitcher />
            <!-- Avatar -->
            <div class="dropdown">
              <a
                class="dropdown-toggle d-flex align-items-center hidden-arrow gap-3"
                href="#"
                id="navbarDropdownMenuAvatar"
                role="button"
                data-mdb-toggle="dropdown"
                data-mdb-display="static"
              >
                <img
                  src="../assets/default-user.png"
                  class="rounded-circle"
                  height="32"
                  width="32"
                  alt="Black and White Portrait of a Man"
                  loading="lazy"
                />

                <span
                  style="font-weight: 500; font-size: 0.875rem; color: #16191e"
                  class="customer-name"
                >
                  -
                </span>
              </a>
              <ul
                class="dropdown-menu dropdown-menu-end mt-10"
                aria-labelledby="navbarDropdownMenuAvatar"
                style="
                  border: 1px solid #dadada;
                  box-shadow: 0 10px 32px 0 #00365b1a;
                  border-radius: 0.5rem;
                  padding: 0.75rem 1rem 1rem;
                  min-width: 12.5rem;
                "
              >
                <li
                  class="d-flex gap-12"
                  style="
                    color: #16191e;
                    padding-bottom: 0.75rem;
                    border-bottom: 1px solid #00365b14;
                  "
                >
                  <span>ID</span>
                  <span class="customer-id" style="overflow-wrap: break-word; color: #00426f"
                    >-</span
                  >
                </li>
                <li
                  style="padding-bottom: 0.75rem; padding-top: 0.75rem"
                  class="d-flex gap-12 cursor-pointer align-items-center mt-8 navbar-item navbar-web remove-share"
                >
                  <img src="../assets/icons/web.svg" alt="web" class="icon-16" />
                  <span class="fs-14 text-335e7c">{{ $t('landing.scanatWeb') }}</span>
                </li>
                <li
                  style="padding-bottom: 0.75rem; padding-top: 0.75rem"
                  class="d-flex gap-12 cursor-pointer align-items-center mb-8px navbar-item navbar-dashboard remove-share"
                >
                  <img src="../assets/icons/dashboard.svg" alt="dashboard" class="icon-16" />
                  <span class="fs-14 text-335e7c">{{ $t('landing.idManage') }}</span>
                </li>
                <li class="text-center">
                  <button
                    type="button"
                    class="btn-outline-primary btn btn-logout w-100"
                    data-mdb-ripple-color="dark"
                    style="
                      font-weight: 500;
                      font-size: 0.875rem;
                      border: 1px solid #0068b0;
                      border-radius: 6px;
                      padding: 5px 1rem;
                      color: #0068b0;
                    "
                  >
                    {{ $t('landing.logout') }}
                  </button>
                </li>
              </ul>
            </div>
          </div>
          <!-- Right elements -->
        </div>
        <!-- Container wrapper -->
      </nav>
      <!-- Navbar -->
    </header>

    <main
      style="margin-top: 16vh; padding-bottom: 8rem"
      class="d-flex justify-content-center flex-column align-items-center gap-48"
    >
      <h1 class="fs-24 fw-bold text-1C2124">{{ $t('landing.select') }}</h1>
      <div class="d-flex gap-72 position-relative">
        <div
          class="d-flex gap-24 flex-column b-r-8 bg-white landing-card cursor-pointer landing-dashboard"
          style="border: 1px solid #ebf3f9; padding: 2rem 1.875rem 1.5625rem 1.875rem"
        >
          <img
            src="../assets/landing/business.svg"
            alt="business"
            style="width: 11.5rem; height: 11.5rem; margin: 0 auto"
          />
          <h2 class="fs-20 text-00365b fw-bold mb-0 text-center" style="margin-top: -6px">
            {{ $t('landing.idManage') }}
          </h2>

          <span class="w-100" style="height: 0; border: 1px dashed #ccd7de"></span>

          <span class="fs-14 text-66869d lh-28 d-inline-block w-320" style="white-space: pre-wrap">
            {{ $t('landing.tipId') }}
          </span>
        </div>
        <div
          class="d-flex gap-24 flex-column p-32 b-r-8 bg-white landing-card cursor-pointer landing-models position-relative"
          style="border: 1px solid #ebf3f9; padding: 2rem 1.875rem 1.5625rem 1.875rem"
        >
          <object
            :data="webSvgUrl"
            type="image/svg+xml"
            style="width: 11.5rem; height: 11.5rem; margin: 0 auto; pointer-events: none"
          >
            <img
              :src="webSvgUrl"
              alt="business"
              style="width: 11.5rem; height: 11.5rem; margin: 0 auto"
            />
          </object>
          <img
            src="../assets/landing/web-beta.svg"
            alt="beta"
            class="position-absolute w-20 top-48"
            style="left: 8.625rem"
          />
          <h2 class="fs-20 text-00365b fw-bold mb-0 text-center" style="margin-top: -6px">
            {{ $t('landing.scanatWeb') }}
          </h2>

          <span class="w-100" style="height: 0; border: 1px dashed #ccd7de"></span>

          <span class="fs-14 text-66869d lh-28 d-inline-block w-320" style="white-space: pre-wrap">
            {{ $t('landing.tipScanat') }}
          </span>
        </div>

        <img
          src="../assets/landing/cube-1.svg"
          alt="cube"
          class="position-absolute"
          style="left: -18.625rem; top: -8rem"
        />
        <img
          src="../assets/landing/cube-2.svg"
          alt="cube"
          class="position-absolute"
          style="left: -11rem; bottom: -4rem"
        />
        <img
          src="../assets/landing/cube-3.svg"
          alt="cube"
          class="position-absolute"
          style="right: -14rem; bottom: -8rem"
        />
      </div>
    </main>
    <ModalNoPermission />
  </div>
</template>

<script setup>
import { watchEffect } from 'vue'
import LanguageSwitcher from 'src/admin/components/common/LanguageSwitcher.vue'
import ModalNoPermission from 'src/admin/components/common/ModalNoPermission.vue'
import i18n from 'src/lang/index.js'
import webSvgUrl from '../assets/landing/web.svg'

const $t = i18n.global.t

watchEffect(() => {
  document.title = $t('landing.select')
})
</script>
